import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex } from 'rebass/styled-components';
import styled from 'styled-components';
import theme from 'styled-theming';
import { FiChevronDown } from 'react-icons/fi';
import { space } from 'styled-system';
import { Title, Subtitle } from '.';

const borderColor = theme('mode', {
  light: (props) => props.theme.colors.reallyLightPurple,
  dark: (props) => props.theme.colors.ghost,
});

const Container = styled(Box)`
  border-top: 1px solid ${borderColor};
`;

const iconColor = theme('mode', {
  light: (props) => props.theme.colors.deepGrey,
});

const Icon = styled(FiChevronDown)`
  ${space}
  stroke-width: 2px;
  color: ${iconColor};
  cursor: pointer;
  transform: scaleY(${(props) => (props.flipped === 'true' ? 1 : -1)});
`;

function Section(props) {
  const {
    title, subtitle, controls, children, isLast, section, ...otherProps
  } = props;

  const [isOpen, setIsOpen] = useState(false);
  const hasSection = typeof section === 'string';

  const toggleSection = () => {
    if (isOpen) {
      localStorage.setItem(section, 'false');
      setIsOpen(false);
    } else {
      localStorage.setItem(section, 'true');
      setIsOpen(true);
    }
  };

  useEffect(() => {
    const value = JSON.parse(localStorage.getItem(section));
    if (hasSection && typeof value === 'boolean') {
      setIsOpen(value);
    }
  }, []); // eslint-disable-line

  return (
    <Container mt={4} pt={4} {...otherProps}>
      <Flex>
        {title && (
          <Title
            fontSize={3}
            fontWeight={400}
            mb={0}
            clickable={hasSection}
            onClick={() => hasSection && toggleSection()}
          >
            {title}
            {section && (
              <Icon
                size={18}
                flipped={hasSection && isOpen.toString()}
                ml={2}
              />
            )}
          </Title>
        )}
      </Flex>
      {
        (!hasSection || (isOpen && subtitle))
        && (<Subtitle mt={2} mb={4}>{subtitle}</Subtitle>
        )
      }
      {(!hasSection || isOpen) && (
        <Box>
          {controls && <Box mb={2}>{controls}</Box>}
          {children}
        </Box>
      )}
    </Container>
  );
}

Section.defaultProps = {
  isLast: false,
  controls: undefined,
  children: undefined,
  title: undefined,
  subtitle: undefined,
  section: undefined,
};

Section.propTypes = {
  isLast: PropTypes.bool,
  controls: PropTypes.node,
  children: PropTypes.node,
  section: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default Section;
